import React, { Component } from 'react'
import { connect } from 'react-redux'
import { List, Toast } from 'antd-mobile'
import { setHeader } from '@/util/set-header'
import { fetchPayBase as fetchPayBaseApi } from '@/api/payment'
import SelectPay from '../common/select-pay/select-pay'
import PayGroup from '../common/pay-group'
import './index.less'
const { Item } = List
const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}

@(connect(mapStateToProps) as any)
export default class HotWater extends Component<any, any> {
  // 热水充值梯度
  private hotWaterLevel = ['10', '20', '40', '60', '80', '100']

  state: any = {
    data: {
      hot_water_fee: {},
      info: {},
    },
    prices: [],
    amount: 1,
    selectPrice: 0,
    loading: true,
  }

  params = {
    pay_type: 'alipay',
    money: '',
  }

  componentDidMount() {
    setHeader({ title: '缴费', leftClick: this.leftClick })
    Toast.loading('加载中', 0)
    const { info } = this.props
    if (info.checkin_id) {
      this.setData(info.checkin_id)
      this.setPrices()
    }
  }

  leftClick = () => {
    //返回App我的订单
    const { history } = this.props
    if(history.length>1){
      history.goBack()
    }else{
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }

  componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    if (info.checkin_id !== nextInfo.checkin_id) {
      this.setData(nextInfo.checkin_id)
      this.setPrices()
    }
  }

  async setData(checkin_id: string) {
    const { data } = await fetchPayBaseApi(checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    this.setState({ data: data.data, loading: false })
  }

  setPrices() {
    this.setState({
      prices: this.hotWaterLevel,
      selectPrice: this.hotWaterLevel[0],
    })
  }

  get total() {
    const { selectPrice } = this.state
    if (selectPrice) {
      return parseFloat(selectPrice)
    }
    return ''
  }

  loadData = () => {
    const { data } = this.state
    const { hot_water_fee } = data
    const { subject_id, subject_name } = hot_water_fee
    return {
      pay_type: this.params.pay_type,
      cost_data: [
        {
          money: this.total,
          subject_id,
          subject_name,
        },
      ],
    }
  }

  render() {
    const { name } = this.props.info
    const { hot_water_fee, info } = this.state.data
    const { prices, selectPrice } = this.state
    const { total } = this
    return (
      <div className="pay-form">
        <List>
          <Item>
            <span className="label">缴费人</span>
            <span className="value">{name}</span>
          </Item>
          <Item>
            <span className="label">房间号</span>
            <span className="value">{`${info.store_no || ''}-${info.room_no ||
              ''}-${info.bed_no || ''}`}</span>
          </Item>
        </List>
        <div className="line" />
        <List>
          <Item>
            <span className="label">缴费项目</span>
            <span className="value subject-name">
              {hot_water_fee.subject_name}
            </span>
          </Item>
          <Item>
            <span className="label">充值金额</span>
            <span className="value">
              {parseFloat(selectPrice).toFixed(2)}元
            </span>
          </Item>
          <Item className="prices" multipleLine={true} wrap={true}>
            {prices &&
              prices.map((price: any, index: number) => (
                <span
                  key={index}
                  className={selectPrice === price ? 'active' : ''}
                  onClick={() => this.setState({ selectPrice: price })}
                >
                  {price}元
                </span>
              ))}
          </Item>
          <SelectPay onChange={type => (this.params.pay_type = type)} />
        </List>
        <div className="bottom-tip">
          <img
            className="icon"
            src="/public/assets/img/redTipIcon.png"
            alt=""
          />
          <span className="tips">完成充值后请去前台更新余额哦</span>
        </div>
        <PayGroup money={total} loadData={this.loadData} />
      </div>
    )
  }
}
